export enum ComponentId {
  ARE_PREVIOUS_DAMAGE_PRESENT = "previousDamage",
  PREVIOUS_DAMAGE_DESCRIPTION = "previousDamageDescription",
  AIRBAGS_DEPLOYED = "airbagsDeployed",
  IS_REPLACEMENT_VEHICLE_REQUIRED = "replacementVehicleRequired",
  IS_VEHICLE_WORKING = "vehicleWorking",
  ARE_OTHER_DAMAGES_PRESENT = "otherDamages",
  OTHER_DAMAGES_DESCRIPTION = "otherDamagesDescription",
}
